import React from "react";
import { useNavigate } from "react-router-dom"; // For navigation
import { AppBar, Toolbar, Button } from "@mui/material";
import ExitToAppIcon from '@mui/icons-material/ExitToApp'; // Logout icon
import axios from '../utils/axiosInstance';

const TopBanner = () => {
  const navigate = useNavigate();

  // Function to navigate to homepage (or any desired route)
  const handleLogoClick = () => {
    navigate("/"); // Redirect to homepage
  };

  // Function to handle logout (redirect to login page or clear auth state)
  const handleLogout = async () => {
    try {
      await axios.post('/auth/logout', {}, { withCredentials: true });
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      navigate('/login');
    }
  };

  return (
    <AppBar 
    position="fixed" 
    color="inherit"
    sx={{
      width: '100%',
      zIndex: 1300, // Highest z-index
      backgroundColor: 'white',
      borderBottom: '2px solid #ccc',
    }}
  >
      <Toolbar
        style={{
          cursor: "pointer",
          padding: "10px 16px",  
          minHeight: "auto",     
          margin: 0,             
          display: "flex",       
          justifyContent: "space-between", // Distribute space between the elements
        }}
      >
        {/* Clickable logo */}
        <div onClick={handleLogoClick}>
          <img
            src="/ciita_logo.png"
            alt="CiiTA Inc"
            style={{ height: 50 }}
          />
        </div>

        {/* Logout Button */}
        <Button
          color="default"  // Use default grey color for the button
          style={{
            textTransform: "none",
            fontSize: "16px",   // Adjust the font size as needed
            padding: "6px 16px", // Padding for the button
            color: "#555",  // Adjust button text color (grey)
            borderColor: "#ccc", // Optional: add border to button
          }}
          variant="outlined"  // You can change to "contained" for a solid button if preferred
          onClick={handleLogout} // Trigger logout when clicked
        >
          <ExitToAppIcon style={{ fontSize: 30 }} />  {/* Door icon */}
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default TopBanner;
